const cardImageStyle = (imgUrl) => {
    return {
        backgroundImage: `url(${imgUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "200px"
      }
}

export default cardImageStyle;